/**
 * Asynchronously loads the component for StudentMESPurchaseDetails
 */

import { lazyLoad } from 'utils/loadable';

export const StudentMESPurchaseDetails = lazyLoad(
  () => import('./index'),
  module => module.StudentMESPurchaseDetails,
);